import { gql } from '@apollo/client';

export const colorCodeFragments = {
  colorCodeItem: gql`
    fragment ColorCodeItem on ColorCode {
      id
      tag
      colorCodeColors {
        id
        wireColor
        sequenceNumber
      }
      colorCodeView {
        colors
        id
      }
      updatedByUser {
        nameFirst
        nameLast
        id
        userAccountPhoto {
          id
          photo
        }
      }
      updatedBy
      updatedTime
    }
  `,
};

export const CREATE_COLOR_CODE = gql`
  ${colorCodeFragments.colorCodeItem}
  mutation CreateColorCode($createColorCodeInput: CreateColorCodeInput!) {
    createColorCode(createColorCodeInput: $createColorCodeInput) {
      errors
      colorCode {
        ...ColorCodeItem
      }
    }
  }
`;

export const UPDATE_COLOR_CODE = gql`
  ${colorCodeFragments.colorCodeItem}
  mutation UpdateColorCode($updateColorCodeInput: UpdateColorCodeInput!) {
    updateColorCode(updateColorCodeInput: $updateColorCodeInput) {
      errors
      colorCode {
        ...ColorCodeItem
      }
    }
  }
`;

export const GET_COLOR_CODE_BY_ID = gql`
  ${colorCodeFragments.colorCodeItem}
  query ColorCodeById($id: ID!) {
    colorCodeById(id: $id) {
      ...ColorCodeItem
    }
  }
`;

export const DELETE_COLOR_CODE = gql`
  mutation DeleteColorCode($deleteColorCodeInput: DeleteColorCodeInput!) {
    deleteColorCode(deleteColorCodeInput: $deleteColorCodeInput) {
      errors
      id
    }
  }
`;

export const SEARCH_COLOR_CODE = gql`
  query SearchColorCodes($searchInput: SearchInput) {
    searchColorCodes(searchInput: $searchInput) {
      items {
        id
        tag
        colorCodeColors {
          id
          wireColor
        }
      }
    }
  }
`;
